import { CssBaseline } from "@mui/material"
import { Game } from "./features/Game"

function App() {
  return (
    <>
      <CssBaseline />
      <Game />
    </>
  )
}

export default App
